export default __webpack_public_path__ + "static/media/human.570000d5.svg";